<div class="tittle-container">
  <span class="tittle">{{title}}</span>
</div>
<mat-divider></mat-divider>
